import { render, staticRenderFns } from "./regAddressInfo.vue?vue&type=template&id=9fc69cd0&scoped=true&"
import script from "./regAddressInfo.vue?vue&type=script&lang=js&"
export * from "./regAddressInfo.vue?vue&type=script&lang=js&"
import style0 from "./regAddressInfo.vue?vue&type=style&index=0&id=9fc69cd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fc69cd0",
  null
  
)

export default component.exports